/**
 * @generated SignedSource<<80fce7d6e8fffb360b7096cb5068246a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarDetails_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"usePdpEstimateSimilarSold_viewer">;
  readonly " $fragmentType": "PdpRespSidebarDetails_viewer";
};
export type PdpRespSidebarDetails_viewer$key = {
  readonly " $data"?: PdpRespSidebarDetails_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarDetails_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    {
      "kind": "RootArgument",
      "name": "isEstimateSimilarSoldVariant"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarDetails_viewer",
  "selections": [
    {
      "condition": "isEstimateSimilarSoldVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "condition": "afterDisplay",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "usePdpEstimateSimilarSold_viewer"
            }
          ]
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "d719a448a073e387e048bf8116af8f95";

export default node;
